export default defineNuxtRouteMiddleware(async (to) => {
  const token = useCookie('auth_token')
  
  // 1. 路由鉴权
  if (!token.value && to.path.startsWith('/user')) {
    return navigateTo('/login')
  }

  // 2. 数据预取（新添加）
  // 只要用户已登录，且 Store 里没有数据，就等待数据加载完再渲染页面
  if (token.value) {
    const userStore = useUserStore()
    if (userStore.user.secretKeyCode === 0) { // 简单判断数据是否已加载
      try {
        await Promise.all([
          userStore.getUserInfo(),
          userStore.getAuthInfo(),
          userStore.getFinanceInfo()
        ])
      } catch (error) {
        console.error('Middleware fetch user data failed:', error)
      }
    }
  }
})
